import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { catchError, delay, switchMap } from 'rxjs/operators';
import { Observable, Subscription, lastValueFrom, of, throwError } from 'rxjs';
import { motivoRechazoMetaApi } from 'src/app/services/meta-api-error-messages';
import { BrokerAdapterFactory } from 'src/app/services/broker-adapter-factory.service';
import { RealTimeService } from 'src/app/services/realtime.service';
import { ConfirmDialogComponent } from '../../common/confirm-dialog/confirm-dialog.component';
import { CookieService } from 'ngx-cookie-service';
import { CerrarPosicionComponent } from '../cerrar-posicion/cerrar-posicion.component';
import { ibrkServices } from 'src/app/services/ibrk.service';
import { SseService } from 'src/app/services/SseService';
import { OAuthService } from 'src/app/services/oauth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PositionsService } from 'src/app/services/Positions.service';
import { global } from 'src/app/global';
import { ToastrService } from 'ngx-toastr';
import { MetaApiService } from 'src/app/services/meta-api.service';
import { BrokerTimeService } from 'src/app/services/broker-time.service';
import { OrdenesSyncService } from 'src/app/services/ordenes-sync.service';
import { esOrdenOco, isooperDeOrderRef, ladoOco, tipoOrdenMt } from 'src/app/shared/utils/order-ref.util';
import { etiquetaOrigenOrden } from 'src/app/shared/pipes/origen-orden.pipe';

type SortDir = 'asc' | 'desc';
interface SortState { campo: string; dir: SortDir; }

type Tabla = 'posiciones' | 'ordenes';
const CLAVE_COLUMNAS = 'brokerOpColumnas';

/** Columna de una tabla: `id` es el campo de la fila (también para ordenar); sin formato, texto. */
interface ColumnaOp {
  id: string;
  nombre: string;
  visible: boolean;
  txt?: boolean;
  formato?: 'precio' | 'cantidad' | 'importe' | 'fecha';
}

/** Estados IBKR / MetaAPI en los que la orden ya no se puede cancelar */
const ESTADOS_ORDEN_FINALES = [
  'Filled', 'Cancelled', 'Canceled', 'Inactive', 'PendingCancel', 'Sincro',
  'ORDER_STATE_FILLED', 'ORDER_STATE_CANCELED', 'ORDER_STATE_REJECTED', 'ORDER_STATE_EXPIRED'
];

const ESTADOS_FILLED = ['Filled', 'ORDER_STATE_FILLED'];

@Component({
  selector: 'app-broker-op-dialog',
  templateUrl: './broker-op-dialog.component.html',
  styleUrl: './broker-op-dialog.component.scss'
})
export class BrokerOpDialogComponent implements OnInit, OnDestroy {
  private storageListener: any;
  public ordenesdb: any[] = [];
  public urlposiciones: any;
  public optimaWallet: any;
  public filaSeleccionada: any;
  /** Filas ya filtradas y ordenadas para la plantilla */
  public ordenes: any[] = [];
  public posiciones: any[] = [];
  public SubOrdenes: Subscription;
  private metaApiOrdersTimeout: any = null;
  public SubPosiciones: Subscription;
  public theme: any;
  public listaPosiciones: any;
  public panelOpenState: boolean = false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }
  public token: any;
  public idcartera: number = 0;
  public nombre: string = '';
  optimawallet: any;
  public licencia: string;
  public idCarteraBroker: String = '0';
  public tipoBroker: string = 'IBKR';
  public metaApiAccountId: string = '';
  private brokerOffsetMin: number | null = null;
  private accountKey: string = '';
  /** /broker está difundiendo posiciones de otra cuenta: la tabla muestra las últimas recibidas de esta */
  public otraCuentaActiva: boolean = false;
  public ultimaActualizacion: number | null = null;
  /** Orden elegido por el usuario; null = orden por defecto (posiciones: el del broker, órdenes: fecha desc) */
  public sortPos: SortState | null = null;
  public sortOrd: SortState | null = null;
  public cancelandoOrdenes = false;
  /** Órdenes recibidas del broker sin filtrar; la tabla muestra el resultado de los filtros abiertos/cerrados */
  private ordenesTodas: any[] = [];
  /** Historial de órdenes de la cartera en BD: no se muestra, solo completa la clasificación abiertos/cerrados */
  private ordenesBd: any[] = [];
  /** tbl_orden.origen de esas órdenes, por order_ref y por orderId. */
  private origenPorOrden = new Map<string, string>();
  public verAbiertos = false;
  public verCerrados = false;
  /** Fuerza el siguiente poll de órdenes MetaAPI (se asigna al arrancar el polling) */
  private refrescarOrdenesMetaApi: ((delayMs: number) => void) | null = null;
  /** Pantalla no disponible para cuentas MetaTrader: no se carga nada y se muestra el aviso */
  public bloqueadoMetaApi = false;
  /** Alto de cada tabla, ajustable con el divisor y persistido en localStorage */
  public altoPosiciones = BrokerOpDialogComponent.leerAlto('brokerOpAltoPosiciones');
  public altoOrdenes = BrokerOpDialogComponent.leerAlto('brokerOpAltoOrdenes');
  private static readonly ALTO_DEFECTO = 330;
  private finResize: (() => void) | null = null;


  /** Columnas al estilo MetaTrader; el resto de datos queda en el panel de columnas, oculto por defecto */
  columnas: Record<Tabla, ColumnaOp[]> = {
    posiciones: [
      { id: 'index', nombre: '#', visible: false, txt: true },
      { id: 'contractId', nombre: 'Id Contrato', visible: false, txt: true },
      { id: 'contractDesc', nombre: 'Símbolo', visible: true, txt: true },
      { id: 'tipo', nombre: 'Tipo', visible: true, txt: true },
      { id: 'volumen', nombre: 'Volumen', visible: true, formato: 'cantidad' },
      { id: 'avgPrice', nombre: 'Precio', visible: true, formato: 'precio' },
      { id: 'sl', nombre: 'S / L', visible: true },
      { id: 'tp', nombre: 'T / P', visible: true },
      { id: 'mktPrice', nombre: 'Actual', visible: true, formato: 'precio' },
      { id: 'beneficio', nombre: 'Beneficio', visible: true },
      { id: 'currency', nombre: 'Moneda', visible: false, txt: true },
      { id: 'coste', nombre: 'Coste', visible: false, formato: 'importe' },
      { id: 'valorActual', nombre: 'Valor Actual', visible: false, formato: 'importe' },
      { id: 'margen', nombre: 'Margen', visible: false, formato: 'importe' },
      { id: 'fechaHoraActual', nombre: 'Fecha', visible: false, txt: true },
    ],
    ordenes: [
      { id: 'index', nombre: '#', visible: false, txt: true },
      { id: 'orderId', nombre: 'Ticket', visible: true, txt: true },
      { id: 'ticker', nombre: 'Símbolo', visible: true, txt: true },
      { id: 'isooper', nombre: 'ID', visible: true, txt: true },
      { id: 'order_ref', nombre: 'Orden Compañía', visible: false, txt: true },
      { id: 'lastExecutionTime_c', nombre: 'Fecha envío', visible: true, txt: true, formato: 'fecha' },
      { id: 'lastExecutionTime_r', nombre: 'Fecha ejecución', visible: true, txt: true, formato: 'fecha' },
      { id: 'tipoMt', nombre: 'Tipo', visible: true, txt: true },
      { id: 'tipoOperacion', nombre: 'Operación', visible: true, txt: true },
      { id: 'totalSize', nombre: 'Volumen', visible: true, formato: 'cantidad' },
      { id: 'filledQuantity', nombre: 'Ejecutadas', visible: true, formato: 'cantidad' },
      { id: 'remainingQuantity', nombre: 'Pendientes', visible: false, formato: 'cantidad' },
      { id: 'precioOrden', nombre: 'Precio', visible: true, formato: 'precio' },
      { id: 'avgPrice', nombre: 'Precio Medio', visible: false, formato: 'precio' },
      { id: 'status', nombre: 'Estado', visible: true, txt: true },
      { id: 'modelo', nombre: 'Modelo', visible: true, txt: true },
      { id: 'origen', nombre: 'Origen', visible: true, txt: true },
    ]
  };
  visibles: Record<Tabla, ColumnaOp[]> = { posiciones: [], ordenes: [] };

  constructor(
    private toastr: ToastrService,
    private _httpClient: HttpClient,
    private datePipe: DatePipe,
    private _realtimeservice: RealTimeService,
    private _cookieService: CookieService,
    public dialog: MatDialog, private _sseservice: SseService,
    public _ibrkService: ibrkServices,
    private cdr: ChangeDetectorRef, public oauthService: OAuthService,
    private route: ActivatedRoute,
    private router: Router, private positionsService: PositionsService,
    private brokerAdapterFactory: BrokerAdapterFactory,
    public metaApiService: MetaApiService,
    private brokerTimeService: BrokerTimeService,
    private ordenesSync: OrdenesSyncService) {
    this.licencia = this._cookieService.get('auth_token');
  }
  ngOnDestroy() {
    this.finResize?.();
    if (this.metaApiOrdersTimeout) clearTimeout(this.metaApiOrdersTimeout);
    if (this.SubOrdenes) this.SubOrdenes.unsubscribe();
    if (this.SubPosiciones) this.SubPosiciones.unsubscribe();
    window.removeEventListener('storage', this.storageListener);
  }
  cargarposiciones() {
    if (this.SubPosiciones) this.SubPosiciones.unsubscribe();
    this.otraCuentaActiva = false;
    this.positionsService.loadCachedFor(this.accountKey);
    this.SubPosiciones = this.positionsService.accountPositions$.subscribe(({ accountKey, positions, ts }) => {
      // Esta pestaña no hace polling: recibe lo que difunde /broker, que puede tener abierta otra cuenta
      if (accountKey === null) return;
      if (accountKey !== this.accountKey) {
        if (!this.otraCuentaActiva) {
          this.otraCuentaActiva = true;
          this.cdr.detectChanges();
        }
        return;
      }
      this.otraCuentaActiva = false;
      this.ultimaActualizacion = ts;
      //recorrer positions y agregar index
      if (positions && Array.isArray(positions)) {
        positions = positions.map((item: any, index: number) => ({
          ...item,
          index: index + 1,
          tipo: Number(item.position) < 0 ? 'sell' : 'buy',
          volumen: Math.abs(Number(item.position)),
        }));
      } else {
        positions = [];
      }
      this.posiciones = positions;
      this.aplicarNiveles();
      this.listaPosiciones = positions;
      this.cargarWhatif();
    });
  }

  cargarWhatif() {
    const dcartera = { nombre: this.nombre };
    this._sseservice.apiPostNew('broker/broker_whatif_ordenes', dcartera, this.token).subscribe({
      next: (respp: any) => {
        let resp = respp?.whatif || [];
        if (!Array.isArray(resp)) return;

        const toNum = (v: any): number | null => {
          if (v === null || v === undefined) return null;
          const n = Number(String(v).replace(/,/g, ''));
          return Number.isFinite(n) ? n : null;
        };

        // Agrupa por conid y suma initial.change y maintenance.change
        const aggByConid = resp.reduce((acc, row: any) => {
          const conid = Number(row?.conid);
          if (!Number.isFinite(conid)) return acc;
          const wi = row?.whatIf;
          const ini = wi?.initial ? toNum(wi.initial.change) : null;
          const mant = wi?.maintenance ? toNum(wi.maintenance.change) : null;
          if (!acc[conid]) acc[conid] = { initial: 0, maintenance: 0 };
          if (ini !== null) acc[conid].initial += ini;
          if (mant !== null) acc[conid].maintenance += mant;
          return acc;
        }, {} as Record<number, { initial: number; maintenance: number }>);

        this.posiciones = this.aplicarOrdenPosiciones(this.posiciones.map((item: any) => {
          const sums = aggByConid[Number(item?.conid)];
          // Mantén un whatIf de referencia (el primero que coincida)
          const match = resp.find((w: any) => Number(w?.conid) === Number(item?.conid));
          const wi = match?.whatIf;

          const margenInicial = sums ? sums.initial : null;
          const margenMantenimiento = sums ? sums.maintenance : null;

          return {
            ...item,
            margen: margenInicial,          // compat con columna actual
            margenInicial,
            margenMantenimiento,
            whatIf: wi                      // opcional: referencia de un whatIf
          };
        }));


        this.ordenesdb = respp?.ordenes || [];
        //recorrer this.dataOrdenes y actualizar con this.ordenesdb el campo modelo.      
           

        this.cdr.detectChanges();
      }
    });
  }

  public previousOrders: any[] = []; // Add this property to track previous orders

  ngOnInit(): void {
    this.cargarColumnas();
    this.token = this._cookieService.get('auth_token');
    this.theme = localStorage.getItem('theme') || 'light-theme';
    this.route.queryParams.subscribe(params => {
      this.idcartera = params['idcartera'];
      this.nombre = params['nombre'];
      this.tipoBroker = params['tipoBroker'] ?? 'IBKR';
      this.metaApiAccountId = params['metaApiAccountId'] ?? '';
      console.log("Parametros recibidos: ", this.idcartera, this.nombre, this.tipoBroker);
      this.optimaWallet = { id: this.idcartera, nombre: this.nombre, tipoBroker: this.tipoBroker, metaApiAccountId: this.metaApiAccountId };
      if (this.tipoBroker === 'METAAPI') {
        this.bloqueadoMetaApi = true;
        return;
      }
      this.accountKey = PositionsService.accountKey(this.tipoBroker, this.nombre, this.metaApiAccountId);
      this.cargarposiciones();
    });
    // queryParams emite de forma síncrona: aquí ya se sabe si la cuenta es MetaTrader
    if (this.bloqueadoMetaApi) return;

    this.idCarteraBroker = localStorage.getItem('idcarterabroker') || '0';
    this.storageListener = (event: StorageEvent) => {
    if (event.key === 'idcarterabroker') {
      this.idCarteraBroker = event.newValue || '0';
      // Trigger change detection
      this.cdr.detectChanges();
    }
  };
  window.addEventListener('storage', this.storageListener);

    // --- MetaAPI order polling ---
    if (this.tipoBroker === 'METAAPI') {
      const wallet = this.optimaWallet;
      const accountId = this.metaApiAccountId || this.nombre;
      const adapter = this.brokerAdapterFactory.getAdapter(wallet);

      const scheduleNext = (delayMs: number) => {
        if (this.metaApiOrdersTimeout) clearTimeout(this.metaApiOrdersTimeout);
        this.metaApiOrdersTimeout = setTimeout(() => doPoll(), delayMs);
      };

      const doPoll = () => {
        if (this.SubOrdenes) this.SubOrdenes.unsubscribe();
        this.SubOrdenes = adapter.getOrders(accountId).subscribe({
          next: (orders: any[]) => {
            if (!orders || !orders.length) {
              this.ordenesTodas = [];
              this.refrescarOrdenes();
            } else {
              const mapped = orders.map((o: any, i: number) => ({
                ...o.raw,
                orderId: o.orderId,
                ticker: o.symbol,
                side: o.side,
                origOrderType: o.orderType,
                status: o.status,
                totalSize: o.quantity,
                remainingQuantity: o.quantity - o.filledQuantity,
                filledQuantity: o.filledQuantity,
                avgPrice: o.limitPrice ?? o.stopPrice ?? 0,
                price: o.limitPrice ?? 0,
                stop_price: o.stopPrice ?? 0,
                lastExecutionTime_c: o.raw?.openingPrice ?? '',
                lastExecutionTime_r: '',
                index: i + 1,
                modelo: ''
              }));
              this.ordenesTodas = mapped;
              this.refrescarOrdenes();
              this.cdr.detectChanges();
              this.cargarOrdenesBd();
            }
            scheduleNext(30000);
          },
          error: (err: any) => {
            const body = err?.error;
            if (body?.error === 'TooManyRequestsError') {
              const retryAt = new Date(body?.metadata?.recommendedRetryTime ?? Date.now() + 300000);
              const delayMs = Math.max(retryAt.getTime() - Date.now(), 60000);
              console.warn(`[MetaAPI] Rate limited on getOrders (dialog). Pausing ${Math.round(delayMs / 1000)}s`);
              scheduleNext(delayMs);
            } else {
              scheduleNext(30000);
            }
          }
        });
      };

      this.refrescarOrdenesMetaApi = scheduleNext;
      doPoll();
      return;
    }

    this.SubOrdenes = this.oauthService.fetchDataEverySecoundsbrk('/iserver/account/orders', 5000).subscribe({
      next: (data: any) => {

        //if(this.idCarteraBroker !== localStorage.getItem('idcarterabroker')) 
          //    this.idCarteraBroker = localStorage.getItem('idcarterabroker') || '0';
            
        const newOrders = data.orders;
        let hasChanges = false;
        // Check if orders have changed
        if (this.previousOrders.length !== newOrders.length) {
          hasChanges = true;
        } else {
          hasChanges = JSON.stringify(this.previousOrders) !== JSON.stringify(newOrders);
        }
        this.previousOrders = [...newOrders]; // Store current orders for next comparison
        // Solo las órdenes de la cuenta abierta (las que no traen acct se mantienen)
        const ordenesCuenta = newOrders.filter((item: { acct?: string }) => !item.acct || item.acct === this.nombre);
        const ordenesMapeadas = ordenesCuenta.map((order: { lastExecutionTime_r: string | number | Date; secType: string; ticker: string,order_ref: string, side: string }) => {
          const isMetaApi = this.tipoBroker === 'METAAPI';
          // MetaAPI: format the true UTC instant in the broker's own timezone
          // (real per-account offset). Other brokers: unchanged legacy adjustment.
          const date = isMetaApi ? new Date(order.lastExecutionTime_r) : this.adjustTimeToConfiguredOffset(order.lastExecutionTime_r);

          const datePart = isMetaApi ? this.brokerTimeService.formatDate(date, this.brokerOffsetMin) : date.toLocaleDateString();
          const timePart = isMetaApi ? this.brokerTimeService.formatTime(date, this.brokerOffsetMin) : date.toLocaleTimeString();
          let nombrecompleto = order.ticker;
          if (order.secType === 'CFD')
            nombrecompleto = order.ticker + ' ' + order.secType;
          const orderr = this.ordenesdb.find((o: any) => o?.orderref === order.order_ref);
          // si modelo != null y modelo > 0 
          let modelo = '';
          if (orderr?.idmodelo && orderr?.idmodelo > 0) {
            modelo = orderr?.idmodelo || '';
          }
          console.log(order.order_ref); // si order_ref es nctminvst17721198133823377-AAPL01:A , entonces quitar nctminvst y tomar los primeros 13 digitos despues de nctminvst y antes de -AAPL01:A para buscar en listaordenes la fechaRegistro y asignarla a lastExecutionTime_c 
          let fecharegistro = order.order_ref?.replace('nctminvst', '').split('-')[0].substring(0, 13);
          let flecha = order.order_ref?.split(':')[1] === 'A' ? '↑' : '↓';
          return {
            ...order,
            fechahora: date,
            lastExecutionDate: datePart,
            lastExecutionTime: timePart,
            tipoOperacion: order.side === 'BUY' ? 'ENTRADA '+ flecha : 'SALIDA '+ flecha,
            ticker: nombrecompleto,
            isooper: isooperDeOrderRef(order.order_ref), // parte entre el primer guion y ':' para mostrar en columna ID
            lastExecutionTime_c: fecharegistro,
            modelo: modelo,
          };
        });




        this.ordenesTodas = ordenesMapeadas;
        this.refrescarOrdenes();

        
        // If orders changed, update positions
        if (hasChanges) {
          this.cargarposiciones();
          this.cargarOrdenesBd();
        }
      }
    });

  }

  /** Órdenes de la cartera en BD (mismo endpoint que Lista Órdenes) para clasificar pares con entradas de otras sesiones */
  private cargarOrdenesBd() {
    this._sseservice.apiPostNew('broker/listaordenes', { idcartera: this.idcartera, tipoBroker: this.tipoBroker }, this.licencia).subscribe({
      next: (data: any) => {
        this.ordenesBd = Array.isArray(data) ? data : [];
        this.origenPorOrden.clear();
        this.ordenesBd.filter(o => o?.origen).forEach(o => {
          if (o.order_ref) this.origenPorOrden.set(String(o.order_ref), o.origen);
          if (o.orderId) this.origenPorOrden.set(String(o.orderId), o.origen);
        });
        // Siempre: la columna Origen sale de estas órdenes, no de la respuesta del broker
        this.refrescarOrdenes();
        this.cdr.detectChanges();
      },
      error: (err: any) => console.error('Error al cargar las órdenes de BD para el filtro abiertos/cerrados', err)
    });
  }
  private adjustTimeToConfiguredOffset(timestamp: string | number | Date): Date {
    const date = new Date(timestamp);
    const gmt4Offset = 0; // Current GMT-4 offset
    const targetOffset = global.timezone.offsetHours;

    // Calculate hours to adjust
    const adjustmentHours = (targetOffset - gmt4Offset) * 3600;

    // Apply the adjustment
    date.setHours(date.getHours() + adjustmentHours);

    return date;
  }
  agregarFechaHoraActualConFormato() {
    const fechaHoraActual = new Date();
    return this.datePipe.transform(fechaHoraActual, 'dd-MM-yyyy HH:mm');
  }

  /** Asigna el número de fila ("#") según el orden final de visualización. */
  private renumerarOrdenes(data: any[]): any[] {
    data.forEach((item, i) => item.index = i + 1);
    return data;
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;
    console.log("this.filaseleccionada: ", this.filaSeleccionada);
  }

  /** Clave estable de la fila: el sondeo crea objetos nuevos y la selección debe sobrevivir */
  private claveFila(row: any): string {
    return row?.orderId !== undefined ? 'o' + row.orderId : 'p' + row?.conid;
  }

  esSeleccionada(row: any): boolean {
    return !!this.filaSeleccionada && this.claveFila(row) === this.claveFila(this.filaSeleccionada);
  }

  trackPos = (_: number, p: any) => this.claveFila(p);
  trackOrden = (_: number, o: any) => this.claveFila(o);

  /** × de la posición: mismo diálogo que el menú "Cerrar" */
  cerrarFila(row: any, event: MouseEvent) {
    event.stopPropagation();
    this.filaSeleccionada = row;
    this.CerrarPosicion();
  }

  /** × de la orden: misma confirmación que el menú "Cancelar Orden" */
  cancelarFila(row: any, event: MouseEvent) {
    event.stopPropagation();
    this.filaSeleccionada = row;
    this.CancelarOrden();
  }

  /** 5 decimales en CFD, 2 en el resto (como el resto de tablas del broker) */
  formatoPrecio(row: any): string {
    return String(row?.secType ?? row?.sectype ?? '').includes('CFD') ? '1.5-5' : '1.2-2';
  }

  /**
   * S/L y T/P de cada posición: órdenes STP/LMT vivas del mismo contrato y de sentido contrario.
   * Sobre todas las órdenes, no las filtradas, para que los filtros no oculten un nivel.
   */
  private aplicarNiveles() {
    const vivas = this.ordenesTodas.filter(o => this.esOrdenCancelable(o) && esOrdenOco(o));
    this.posiciones.forEach(pos => {
      const ladoSalida = Number(pos.position) < 0 ? 'BUY' : 'SELL';
      const delContrato = vivas.filter(o => String(o.side ?? '').toUpperCase() === ladoSalida && this.mismoContrato(o, pos));
      (['sl', 'tp'] as const).forEach(lado => {
        const niveles = delContrato.filter(o => ladoOco(o) === lado);
        pos[lado + 'Ordenes'] = niveles;
        pos[lado] = niveles.length ? this.precioOrden(niveles[0]) : null;
        pos[lado + 'Tooltip'] = niveles.map(o => '#' + o.orderId + ': ' + (this.precioOrden(o) ?? '')).join('\n');
      });
    });
    this.posiciones = this.aplicarOrdenPosiciones(this.posiciones);
  }

  /** Por conid; si la orden no lo trae, por símbolo (sin el sufijo " CFD" que se añade al mapear) */
  private mismoContrato(orden: any, pos: any): boolean {
    if (orden.conid != null && pos.conid != null) return Number(orden.conid) === Number(pos.conid);
    return String(orden.ticker ?? '').replace(/ CFD$/, '') === String(pos.contractDesc ?? '');
  }

  /** Precio de la orden: el de stop en las STP, el límite en el resto; null si no tiene */
  private precioOrden(o: any): number | null {
    const precio = esOrdenOco(o) && ladoOco(o) === 'sl'
      ? Number(o.stop_price) || Number(o.auxPrice) || Number(o.price)
      : Number(o.price);
    return Number.isFinite(precio) && precio !== 0 ? precio : null;
  }

  // ── Columnas ──────────────────────────────────────────────────────────────

  private cargarColumnas() {
    try {
      const ocultas = JSON.parse(localStorage.getItem(CLAVE_COLUMNAS) || '{}');
      (Object.keys(this.columnas) as Tabla[]).forEach(t =>
        Array.isArray(ocultas[t]) && this.columnas[t].forEach(c => c.visible = !ocultas[t].includes(c.id)));
    } catch { /* sin preferencias guardadas */ }
    this.actualizarVisibles();
  }

  toggleColumna(col: ColumnaOp) {
    col.visible = !col.visible;
    this.actualizarVisibles();
    try {
      const ocultas: Record<string, string[]> = {};
      (Object.keys(this.columnas) as Tabla[]).forEach(t =>
        ocultas[t] = this.columnas[t].filter(c => !c.visible).map(c => c.id));
      localStorage.setItem(CLAVE_COLUMNAS, JSON.stringify(ocultas));
    } catch { /* almacenamiento no disponible */ }
  }

  private actualizarVisibles() {
    (Object.keys(this.columnas) as Tabla[]).forEach(t => this.visibles[t] = this.columnas[t].filter(c => c.visible));
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    console.log(this.filaSeleccionada);
  }

  /** Clic en cabecera: asc → desc → asc… (cambiar de columna empieza en asc) */
  private siguienteOrden(actual: SortState | null, campo: string): SortState {
    return actual?.campo === campo && actual.dir === 'asc' ? { campo, dir: 'desc' } : { campo, dir: 'asc' };
  }

  orderByPosiciones(campo: string) {
    this.sortPos = this.siguienteOrden(this.sortPos, campo);
    this.posiciones = this.aplicarOrdenPosiciones([...this.posiciones]);
    this.cdr.detectChanges();
  }

  orderBy(campo: string) {
    this.sortOrd = this.siguienteOrden(this.sortOrd, campo);
    this.refrescarOrdenes();
    this.cdr.detectChanges();
  }

  toggleFiltroOrdenes(filtro: 'abiertos' | 'cerrados') {
    if (filtro === 'abiertos') this.verAbiertos = !this.verAbiertos;
    else this.verCerrados = !this.verCerrados;
    this.refrescarOrdenes();
    this.cdr.detectChanges();
  }

  /** Vuelve a pintar la tabla de órdenes (filtros abiertos/cerrados + orden + numeración) y los S/L-T/P de las posiciones */
  private refrescarOrdenes() {
    this.ordenesTodas.forEach(o => {
      o.origen = etiquetaOrigenOrden(this.origenPorOrden.get(String(o.order_ref)) ?? this.origenPorOrden.get(String(o.orderId)));
      o.tipoMt = tipoOrdenMt(o);
      o.precioOrden = this.precioOrden(o);
    });
    this.ordenes = this.aplicarOrdenOrdenes(this.filtrarOrdenes(this.ordenesTodas));
    this.aplicarNiveles();
  }

  /**
   * Pares por ID (isooper), clasificados con sus órdenes Filled: cerrado si hay BUY y SELL Filled,
   * abierto si solo un lado. Mismo criterio que Lista Órdenes. Solo se muestran órdenes del broker;
   * los lados Filled se toman del broker y de la BD, porque IBKR solo devuelve las órdenes de la sesión
   * y la entrada de un par puede ser de otro día.
   */
  private filtrarOrdenes(data: any[]): any[] {
    if (!this.verAbiertos && !this.verCerrados) return [...data];
    const ladosFilled = new Map<string, Set<string>>();
    const anotar = (orden: any, isooper: string) => {
      if (!isooper || !ESTADOS_FILLED.includes(orden?.status)) return;
      if (!ladosFilled.has(isooper)) ladosFilled.set(isooper, new Set());
      ladosFilled.get(isooper)!.add(String(orden.side ?? '').toUpperCase());
    };
    this.ordenesBd.forEach(o => anotar(o, isooperDeOrderRef(o?.order_ref)));
    data.forEach(o => anotar(o, o.isooper));
    return data.filter(o => {
      const lados = ladosFilled.get(o.isooper);
      if (!lados?.size) return false;
      const cerrado = lados.has('BUY') && lados.has('SELL');
      return cerrado ? this.verCerrados : this.verAbiertos;
    });
  }

  /** Icono de la cabecera según el orden activo de la tabla */
  iconoOrden(sort: SortState | null, campo: string): string | null {
    if (sort?.campo !== campo) return null;
    return sort.dir === 'asc' ? 'arrow_upward' : 'arrow_downward';
  }

  private aplicarOrdenPosiciones(data: any[]): any[] {
    if (!this.sortPos) return data;
    return this.renumerarOrdenes(this.ordenarPor(data, this.sortPos));
  }

  private aplicarOrdenOrdenes(data: any[]): any[] {
    return this.renumerarOrdenes(this.sortOrd ? this.ordenarPor(data, this.sortOrd) : this.sortByFechaHora(data));
  }

  /** Números (también los que llegan como texto) numéricamente, fechas dd-MM-yyyy por fecha y el resto como texto; vacíos al final */
  private ordenarPor(data: any[], sort: SortState): any[] {
    const signo = sort.dir === 'asc' ? 1 : -1;
    return data.sort((a, b) => {
      const va = this.valorOrdenable(a?.[sort.campo]);
      const vb = this.valorOrdenable(b?.[sort.campo]);
      if (va === null && vb === null) return 0;
      if (va === null) return 1;
      if (vb === null) return -1;
      if (typeof va === 'number' && typeof vb === 'number') return (va - vb) * signo;
      return String(va).localeCompare(String(vb), 'es', { numeric: true, sensitivity: 'base' }) * signo;
    });
  }

  private valorOrdenable(v: any): number | string | null {
    if (v === null || v === undefined || v === '') return null;
    if (typeof v === 'number') return Number.isFinite(v) ? v : null;
    if (v instanceof Date) return v.getTime();
    const s = String(v).trim();
    const fecha = /^(\d{2})-(\d{2})-(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(s);
    if (fecha) {
      const [, dd, mm, yyyy, hh = '0', mi = '0', ss = '0'] = fecha;
      return new Date(+yyyy, +mm - 1, +dd, +hh, +mi, +ss).getTime();
    }
    const n = Number(s.replace(/,/g, ''));
    return Number.isFinite(n) ? n : s;
  }

  sortByFechaHora(dataArray: any[]): any[] {
    return dataArray.sort((a, b) => {
      const dateA = new Date(a.fechahora).getTime();
      const dateB = new Date(b.fechahora).getTime();
      return dateB - dateA;
    });
  }

  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  CerrarPosicionTodas() {
    this.brokerAdapterFactory.puedeOperar(this.tipoBroker).subscribe(ok => { if (ok) this.CerrarPosicionTodasConfirmado(); });
  }

  private CerrarPosicionTodasConfirmado() {
    this._sseservice.apiGetNew('ordenes-pendientes/' + this.idcartera).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '380px',
            height: '250px',
            panelClass: this.theme,
            data: {
              msj: '¿Desea cerrar todas las posiciones en el bróker? Se cancelarán todas las órdenes pendientes y las posiciones cerradas solo se registrarán en este módulo, no en la cartera gestionada. Si desea que las operaciones queden registradas en la cartera gestionada, deberá realizar el cierre de posiciones desde la pestaña Cartera', icon: 'warning'
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              console.log('cerrar todas las posiciones');
              for (const orden of data) {
                this.cancelarOrdenBroker(orden.orderId).subscribe({
                  next: () => console.log("Orden Cancelada: ", orden.orderId),
                  error: (error: any) => console.error("Error al cancelar la orden: ", error)
                });
              }
              // Da tiempo a que las cancelaciones lleguen a la BD antes de avisar a /broker
              setTimeout(() => this.ordenesCanceladas(), 3000);
              this.cerrarPosicionesConIntervalo();
            }
          });
        } else {
          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '380px',
            height: '250px',
            panelClass: this.theme,
            data: {
              msj: 'Esta seguro de cerrar todas las posiciones?, Las posiciones cerradas no se registraran en cartera.', icon: 'warning'
            }
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result) {
              console.log('cerrar todas las posiciones');
              this.cerrarPosicionesConIntervalo();
            }
          });
        }
      }
    });

  }
  private actualizarEstadoOrden(orderId: string): Observable<any> {
    return this.oauthService.apiGetIbrk('/iserver/account/order/status/' + orderId).pipe(
      switchMap((data: any) => {
        console.log("Estado de orden:", data);
        return this._sseservice.apiPostNew('broker/actualizarOrdenEstado', data, this.licencia);
      })
    );
  }
  async cerrarPosicionesConIntervalo() {
    for (const data of this.posiciones) {
      console.log("ESTO ENVIAMOS A BROKER " + data);
      await this.cerrarPosicionYEsperar(data);
    }
  }

  async cerrarPosicionYEsperar(data: any) {
    return new Promise<void>((resolve) => {
      if (this.tipoBroker === 'METAAPI') {
        const accountId = this.metaApiAccountId || this.nombre;
        const trade = { actionType: 'POSITION_CLOSE_ID', positionId: String(data.conid) };
        this.brokerAdapterFactory.getAdapter(this.optimaWallet).placeOrder(accountId, trade).subscribe({
          next: (res: any) => {
            const rechazo = motivoRechazoMetaApi(res);
            if (rechazo) this.toastr.error('No se pudo cerrar la posición ' + data.conid + ': ' + rechazo, 'Error');
            setTimeout(() => resolve(), 500);
          },
          error: (err: any) => { console.error('MetaAPI close position error', err); resolve(); }
        });
      } else {
        cerrarposiciones(data, '/iserver/account/' + this.nombre + '/orders', this.nombre, this.oauthService, this._sseservice, this.licencia);
        setTimeout(() => { resolve(); }, 2000);
      }
    });
  }


  CerrarPosicion() {
    this._sseservice.apiGetNew('ordenes-pendientes/' + this.idcartera).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          let encontradopendiente = false;
              for (const orden of data) {
                console.log("Orden Pendiente: ", orden.ticker+ " - " + this.filaSeleccionada.contractDesc);
                if(orden.ticker === this.filaSeleccionada.contractDesc){
                  this.toastr.error('No se puede cerrar la posición, tiene una orden pendiente: ' + orden.ticker, 'Error');
                  encontradopendiente = true;
                }
              }
              if(!encontradopendiente){
                if (this.filaSeleccionada.position == 0) {
                  const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                    width: '380px',
                    height: '250px',
                    panelClass: this.theme,
                    data: {
                      msj: 'Numero de Acciones debe ser Mayor a 0'
                    }
                  });
                } else {
                  const dialogRef = this.dialog.open(CerrarPosicionComponent, {
                    width: '380px',
                    height: '440px',
                    panelClass: this.theme,
                    data: {
                      posicion: this.filaSeleccionada,
                      listaPosiciones: this.listaPosiciones,
                      optimaWallet: this.optimaWallet,
                      tipoBroker: this.tipoBroker,
                      metaApiAccountId: this.metaApiAccountId
                    }
                  });
                }
              }

        }else{
        //return;
            if (this.filaSeleccionada.position == 0) {
              const dialogRef = this.dialog.open(ConfirmDialogComponent, {
                width: '380px',
                height: '250px',
                panelClass: this.theme,
                data: {
                  msj: 'Numero de Acciones debe ser Mayor a 0'
                }
              });
            } else {
              const dialogRef = this.dialog.open(CerrarPosicionComponent, {
                width: '380px',
                height: '440px',
                panelClass: this.theme,
                data: {
                  posicion: this.filaSeleccionada,
                  listaPosiciones: this.listaPosiciones,
                  optimaWallet: this.optimaWallet,
                  tipoBroker: this.tipoBroker,
                  metaApiAccountId: this.metaApiAccountId
                }
              });
            }
          }

        }
    });



    
  }
  esOrdenCancelable(orden: any): boolean {
    return !!orden && orden.orderId !== undefined && orden.orderId !== null && orden.orderId !== ''
      && !ESTADOS_ORDEN_FINALES.includes(String(orden.status ?? '').trim());
  }

  /**
   * Cancela la orden en el broker y deja la BD al día para que /broker → Órdenes la vea cancelada:
   * IBKR → DELETE + order/status → broker/actualizarOrdenEstado; MetaAPI → cancelOrder + metaapi/cancelarOrden.
   * Un fallo al actualizar la BD no se trata como fallo de la cancelación.
   */
  private cancelarOrdenBroker(orderId: string | number): Observable<any> {
    const id = String(orderId);
    if (this.tipoBroker === 'METAAPI') {
      const accountId = this.metaApiAccountId || this.nombre;
      return this.brokerAdapterFactory.getAdapter(this.optimaWallet).cancelOrder(accountId, id).pipe(
        switchMap((res: any) => {
          // Rechazada en el broker: la orden sigue viva, no se marca cancelada en BD
          const rechazo = motivoRechazoMetaApi(res);
          return rechazo ? throwError(() => new Error(rechazo)) : of(res);
        }),
        switchMap(() => this._sseservice.apiPostNew('metaapi/cancelarOrden', { order_id: Number(id) }, this.licencia).pipe(
          catchError(err => { console.error('Error al marcar cancelada en BD la orden MetaAPI ' + id, err); return of(null); })
        ))
      );
    }
    return this.oauthService.apiDeleteIbrk('/iserver/account/' + this.nombre + '/order/' + id).pipe(
      switchMap(() => this.actualizarEstadoOrden(id).pipe(
        catchError(err => { console.error('Error al actualizar en BD el estado de la orden ' + id, err); return of(null); })
      ))
    );
  }

  /** Tras cancelar: avisa a /broker (otra pestaña) y refresca esta tabla sin esperar al polling */
  private ordenesCanceladas() {
    this.ordenesSync.notificarCambio(this.idcartera);
    this.refrescarOrdenesMetaApi?.(1000);
  }

  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  CancelarTodasOrdenes() {
    this.brokerAdapterFactory.puedeOperar(this.tipoBroker).subscribe(ok => { if (ok) this.CancelarTodasOrdenesConfirmado(); });
  }

  private CancelarTodasOrdenesConfirmado() {
    // Sobre todas las órdenes, no solo las filtradas: no dejar órdenes vivas ocultas por el filtro
    const ordenes = this.ordenesTodas.filter(o => this.esOrdenCancelable(o));
    if (ordenes.length === 0) {
      this.toastr.info('No hay órdenes pendientes para cancelar', 'Órdenes');
      return;
    }
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: '¿Desea cancelar ' + ordenes.length + (ordenes.length === 1 ? ' orden pendiente' : ' órdenes pendientes') +
          ' en el bróker? Se incluyen las órdenes Take Profit / Stop Loss: las posiciones abiertas quedarán sin protección.',
        icon: 'warning'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) this.cancelarOrdenesEnSecuencia(ordenes);
    });
  }

  /** Una a una con pausa entre órdenes para no saturar al broker (rate limit IBKR / MetaAPI) */
  private async cancelarOrdenesEnSecuencia(ordenes: any[]) {
    this.cancelandoOrdenes = true;
    const pausaMs = this.tipoBroker === 'METAAPI' ? 500 : 1000;
    let canceladas = 0;
    let errores = 0;
    for (const orden of ordenes) {
      try {
        await lastValueFrom(this.cancelarOrdenBroker(orden.orderId), { defaultValue: null });
        canceladas++;
      } catch (err) {
        errores++;
        console.error('Error al cancelar la orden ' + orden.orderId, err);
      }
      await new Promise(resolve => setTimeout(resolve, pausaMs));
    }
    this.cancelandoOrdenes = false;
    if (errores === 0) {
      this.toastr.success(canceladas + (canceladas === 1 ? ' orden cancelada' : ' órdenes canceladas'), 'Órdenes');
    } else {
      this.toastr.warning(canceladas + ' canceladas, ' + errores + ' con error', 'Órdenes');
    }
    this.ordenesCanceladas();
    this.cdr.detectChanges();
  }

  /** MetaTrader con Algo Trading desactivado: aviso y no se inicia el flujo. */
  CancelarOrden() {
    this.brokerAdapterFactory.puedeOperar(this.tipoBroker).subscribe(ok => { if (ok) this.CancelarOrdenConfirmado(); });
  }

  private CancelarOrdenConfirmado() {
    console.log("CancelarOrden ", this.filaSeleccionada);
    if (!this.esOrdenCancelable(this.filaSeleccionada)) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'No se Pueden Cancelar Ordenes en estado ' + this.filaSeleccionada.status
        }
      });
    } else {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '380px',
        height: '250px',
        panelClass: this.theme,
        data: {
          msj: 'Esta Seguro de Cancelar la Orden ' + this.filaSeleccionada.ticker + ' - ' + this.filaSeleccionada.orderId
        }
      });
      const orden = this.filaSeleccionada;
      dialogRef.afterClosed().subscribe(result => {
        console.log('El diálogo se cerró');
        if (result) {
          this.cancelarOrdenBroker(orden.orderId).subscribe({
            next: () => {
              this.toastr.success('Orden cancelada correctamente', 'Éxito');
              this.ordenesCanceladas();
            },
            error: (err: any) => this.toastr.error('Error al cancelar la orden: ' + (err?.error?.message ?? err?.message ?? err), 'Error')
          });
        } else {
          console.log('La acción fue cancelada');
        }
      });
    }
  }


  EliminarOrden() {
    console.log("EliminarOrden ", this.filaSeleccionada);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '380px',
      height: '250px',
      panelClass: this.theme,
      data: {
        msj: 'Esta Seguro de Cancelar la Orden' + this.filaSeleccionada.conid
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('El diálogo se cerró');
      if (result) {
        let url = '/api/broker/eliminarOrden/' + this.filaSeleccionada.conid;
        this._sseservice.apiDelete(url, this.token).subscribe({
          next: (data: any) => {
            console.log("RESPUESTA  DEL DELETE: ", data);
          }
        });
      } else {
        console.log('La acción fue cancelada');
      }
    });
  }
  private static leerAlto(clave: string): number {
    try {
      const alto = Number(localStorage.getItem(clave));
      if (alto > 0) return alto;
    } catch { }
    return BrokerOpDialogComponent.ALTO_DEFECTO;
  }

  /** Arrastre del divisor bajo una tabla: abajo la agranda, arriba la achica. */
  iniciarResize(ev: MouseEvent, panel: 'posiciones' | 'ordenes') {
    ev.preventDefault();
    this.finResize?.();
    const prop = panel === 'posiciones' ? 'altoPosiciones' : 'altoOrdenes';
    const clave = panel === 'posiciones' ? 'brokerOpAltoPosiciones' : 'brokerOpAltoOrdenes';
    const startY = ev.clientY;
    const altoInicial = this[prop];
    const max = Math.round(window.innerHeight * 0.7);
    const mover = (e: MouseEvent) => {
      this[prop] = Math.min(max, Math.max(80, altoInicial + e.clientY - startY));
      this.cdr.detectChanges();
    };
    const soltar = () => {
      document.removeEventListener('mousemove', mover);
      document.removeEventListener('mouseup', soltar);
      document.body.style.userSelect = '';
      this.finResize = null;
      try { localStorage.setItem(clave, String(this[prop])); } catch { }
    };
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    this.finResize = soltar;
  }

  /** Doble clic en el divisor: vuelve al alto por defecto. */
  resetAlto(panel: 'posiciones' | 'ordenes') {
    if (panel === 'posiciones') this.altoPosiciones = BrokerOpDialogComponent.ALTO_DEFECTO;
    else this.altoOrdenes = BrokerOpDialogComponent.ALTO_DEFECTO;
    try { localStorage.removeItem(panel === 'posiciones' ? 'brokerOpAltoPosiciones' : 'brokerOpAltoOrdenes'); } catch { }
    this.cdr.detectChanges();
  }

  close() {
    window.close();
  }

}



function cerrarposiciones(this: any, data: any, URLNEW: string, nombreCuenta: string, oauthService: OAuthService, sseservice: SseService, licencia: string) {
  let ordersDatam = {
    orders: [
      {
        orderType: 'MKT',
        ticker: 'AAPL',
        side: 'SELL',
        quantity: 0,
        remainingquantity: 0,
        acctId: 'DU149954',
        cOID: 'nctminvst1714425916446-AAPL0:A',
        secType: '265598:STK',
        filledquantity: 0,
        parentId: 'nctminvst1714425916446-AAPL0:A',
        tif: 'GTC',
        outsideRTH: false,
        referrer: 'modelosdeinversion',
        useAdaptive: false,
        conid: 0
      }
    ]
  };
  console.log(data);
  let fechaMilisegundos = new Date().getTime();
  let side: string = '';
  if (data.position > 0) {
    side = 'SELL';
  } else if (data.position < 0) {
    side = 'BUY';
  } console.log("ESTO ENVIAMS A BROKER");
  if (data.position !== 0) {
    ordersDatam.orders[0].ticker = data.contractDesc;
    ordersDatam.orders[0].quantity = Math.abs(data.position);//side
    ordersDatam.orders[0].side = side;
    ordersDatam.orders[0].acctId = nombreCuenta;
    ordersDatam.orders[0].cOID = 'nctminvst' + fechaMilisegundos + '-' + data.contractDesc + ':A';
    ordersDatam.orders[0].secType = data.conid + ':' + data.assetClass;
    ordersDatam.orders[0].parentId = 'nctminvst' + fechaMilisegundos + '-' + data.contractDesc + ':A';
    ordersDatam.orders[0].conid = Number(data.conid);
    console.log("ESTO ENVIAMS A BROKER: ", ordersDatam);
    //   let licencia = this._cookieService.get('auth_token');
    let urlwhatif = '/iserver/account/' + nombreCuenta + '/orders/whatif';
    oauthService.apiPostIbrk(urlwhatif, ordersDatam).subscribe({
      next: (data: any) => {
        if (Number(data.position.after) === 0) {
          //sseservice.apiPostNew('broker/orderNuevo', ordersDatam.orders, licencia).subscribe({
            //next: (response: any) => {
              oauthService.apiPostIbrk(URLNEW, ordersDatam).subscribe({
                  next: (data: any) => {
                    console.log("ESTO RESPONDE BROKER", data);
                    if (data[0].message) {
                      let url = '/iserver/reply/' + data[0].id;
                      console.log("esto es el url")
                      let dataJson = { confirmed: true }
                      let msj = '';
                      oauthService.apiPostIbrk(url, dataJson).subscribe({
                        next: (data: any) => {
                          console.log("DATOS DESDE REPLY: ", data);
                          if (data[0]) {
                            if (data[0].message) {
                              console.log("esta es la orden a confirmar: ", data[0].id);
                              this.confirmarOp(data[0].id);
                              this._brokerService.updatecargarListas(true);//darle una vuelta a      
                            }
                          }
                        }
                      });
                    }
                  }
                });
           // },
            //error: (error:any) => {
           //   console.error('Error al enviar la orden:', error);
          //  }
         // });


          
        }
      }
    });
  }
}

